import {
    apiGetClient,
    apiPostClient,
    apiPostImageClient,
    apiPutClient,
    apiPutImageClient,
} from "../../api/apiSurveyService";

import { toast } from "react-toastify";
import i18n from "i18next";
const t = i18n.t.bind(i18n);

export const getAllSurveys = async () => {
    try {
        const response = await apiGetClient.get("admin");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const createNewSurvey = async (data) => {
    try {
        const response = await apiPostClient.post("admin", data);
        toast.success(response.data?.data, { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const getAllSurveyImages = async () => {
    try {
        const response = await apiGetClient.get("admin/images");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getAllQuestionTypes = async (languageId) => {
    try {
        const response = await apiGetClient.get(`admin/question-types/${languageId}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getDistributionList = async () => {
    try {
        const response = await apiGetClient.get("admin/distribution-lists");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const addNewSurveyImage = async (data) => {
    try {
        const response = await apiPostImageClient.post("admin/images", data);
        toast.success(response.data?.data, { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

// Publish Survey
export const publishSurvey = async (data, id) => {
    try {
        const response = await apiPutClient.put(`admin/${id}/publish`, data);
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

// Active Survey
export const activateSurvey = async (data, id) => {
    try {
        const response = await apiPutClient.put(
            `admin/${data?.surveyId}/activate`,
            data
        );
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

// De Activate Survey
export const deActivateSurvey = async (data) => {
    try {
        const response = await apiPutClient.put(
            `admin/${data?.surveyId}/deactivate`,
            data
        );
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

// Delete Survey
export const deleteSurvey = async (payload) => {
    try {
        const response = await apiPostClient.delete(
            `admin/${payload.surveyId}/delete/${payload.languageId}`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

// Reminder Survey
export const reminderSurvey = async (data, link) => {
    try {
        const response = await apiPostClient.post(
            `admin/${data.surveyId}/reminder?SurveyLink=${link}`,
            data
        );
        return response.data;
    } catch (error) {
        return null;
    }
};

export const getSasToken = async () => {
    try {
        const response = await apiGetClient.get("surveys/survey-images/sas");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getSurveyDetails = async (data) => {
    try {
        const response = await apiGetClient.get(
            // `surveys/${data.surveyId}/code/${data.code}`
            `surveys/${data.surveyId}/code/${data.languageId}?code=${data.code}`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getReminderTemplate = async (surveyId, languageId) => {
    try {
        const response = await apiGetClient.get(
            `admin/getReminderTemplate/${surveyId}/${languageId}`
        );
        return response.data;
    } catch (error) {
        return null;
    }
};

// Publish Survey
export const extendSurvey = async (data, id) => {
    try {
        const response = await apiPutClient.put(
            `admin/${id}/extend?newEnddate=${data?.newEnddate}`,
            data
        );
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

//Check for duplicate survey title
export const checkDuplicateSurveyTitle = async (title, languageId) => {
    try {
        const response = await apiGetClient.get(
            `admin/check-duplicate-title/${languageId}?title=${title}`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

// Get survey data for excel export
export const getSurveyDataForExcel = async (surveyId, languageId) => {
    try {
        const response = await apiGetClient.get(
            `admin/GetSurveyData/${surveyId}/${languageId}`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

// Delete Image
export const deleteSurveyImage = async (payload) => {
    try {
        const response = await apiPostClient.delete(
            `admin/images/${payload?.imageId}/remove`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getSurveyResponses = async (surveyId, languageId) => {
    try {
        const response = await apiGetClient.get(
            `/admin/surveys/${surveyId}/surveyresponse/${languageId}`
        );
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.error, { position: "top-center" });
        return error?.response?.data?.data;
    }
};

export const getSurveyFreeTextResponses = async (surveyId, languageId) => {
    try {
        const response = await apiGetClient.get(
            `/admin/surveys/${surveyId}/userresponse/${languageId}`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data?.error, { position: "top-center" });
        return null;
    }
};

export const getNumberOfSurveyResponses = async (surveyId) => {
    try {
        const response = await apiGetClient.get(
            `/admin/surveys/${surveyId}/responsecount`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getEditSurveyDetails = async (surveyId, languageId) => {
    try {
        const response = await apiGetClient.get(`/admin/${surveyId}/details/${languageId}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const updateSurvey = async (data, surveyId) => {
    try {
        const response = await apiPostClient.put(
            `/admin/${surveyId}/update`,
            data
        );
        toast.success(
            t("surveyUpdatedSuccess", { title: data?.title }),
            { position: "top-center" }
        );
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

// Publish Survey
export const rePublishSurvey = async (data, id) => {
    try {
        const response = await apiPutClient.put(`admin/${id}/republish`, data);
        return response.data;
    } catch (error) {
        let errorData = error.response.data;

        if (error?.status === 409) {
            toast.error(errorData?.error, { position: "top-center" });
            return null;
        }
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const getSurveyRecipients = async (surveyId) => {
    try {
        const response = await apiGetClient.get(
            `/admin/surveys/${surveyId}/recipients`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};


export const uploadNewSurvey = async (payload, data) => {
    try {
        const response = await apiPostImageClient.post(`admin/${data?.surveyId}/upload/${data?.languageId}`, payload);
        toast.success(response.data?.data, { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};
